///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Imports
//
///////////////////////////////////////////////////////////////////////////////////////////////////

import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.calendars = abcsetup.calendars || {};

abcsetup.calendars = {
    calendar: null,

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    renderCalendar: function (calendarEl, options) {

        if(!options.eventMouseEnter){
            options.eventMouseEnter = function(mouseEnterInfo){
                mouseEnterInfo.el.style.cursor = "pointer";
                let date = moment(mouseEnterInfo.event.start).format('l') + (mouseEnterInfo.event.end ? " - " + moment(mouseEnterInfo.event.end).format('l') : "");
                let startDate = moment(mouseEnterInfo.event.start);
                let originalEndDate = moment(mouseEnterInfo.event.extendedProps.originalEndDate);
                
                if (mouseEnterInfo.event.extendedProps.is_advertisement) {
                    // If it's an advertisement, use originalEndDate to ensure the correct month is displayed
                    if (startDate.date() !== 1) {
                        startDate = startDate.month(originalEndDate.month()).year(originalEndDate.year()).date(1);
                    }
        
                    // If it's an advertisement, use originalEndDate to ensure the correct end date is displayed
                    date = startDate.format('l') + 
                        (mouseEnterInfo.event.extendedProps.originalEndDate 
                            ? " - " + moment(mouseEnterInfo.event.extendedProps.originalEndDate).format('l') 
                            : "");
                } else {
                    // Otherwise, use the normal end date
                    date = moment(mouseEnterInfo.event.start).format('l') + 
                        (mouseEnterInfo.event.end ? " - " + moment(mouseEnterInfo.event.end).format('l') : "");
                }

                $(mouseEnterInfo.el).popover({
                    title: mouseEnterInfo.event.title,
                    content: date
                });
            }
        }
        this.calendar = new abcsetup.calendars.FullCalendar(calendarEl, options);
        this.calendar.render();
    },
    FullCalendar: Calendar,


    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Variables
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    availablePlugins: {dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin},
};